import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { bugsnag } from 'shared/utils/services/bugsnag';

export interface IShareButtonProps extends ShareData {
  className?: string;
  'data-qa'?: string;
  children?: ReactNode;
  hideIfUnavailable?: boolean;
  onShared?: () => void;
  onError?: (error) => void;
}

export const ShareButton = ({
  className,
  children,
  'data-qa': dataQa = 'share_button',
  hideIfUnavailable = true,
  onShared,
  onError,
  ...shareData
}: IShareButtonProps) => {
  const { t } = useTranslation();

  const isSharingAvailable = Boolean(navigator?.share) && Boolean(navigator?.canShare);
  const canShare = isSharingAvailable && navigator.canShare(shareData);

  const share = async () => {
    if (!canShare) return;

    try {
      await navigator.share(shareData);
      onShared?.();
    } catch (error) {
      bugsnag(error, { context: 'Failed Share Attempt' });
      onError?.(error);
    }
  };

  if (!isSharingAvailable && hideIfUnavailable) return null;

  return (
    <button
      className={className}
      data-qa={dataQa}
      onClick={share}
      disabled={!canShare}
      type="button"
    >
      {children ?? t('shared.share', 'Share')}
    </button>
  );
};
